const BYTES_PER_UNIT = 1024;
const DECIMAL_PLACES_ABOVE_BYTES = 1;
const FILE_SIZE_UNITS = ['B', 'KB', 'MB', 'GB'] as const;
const LAST_UNIT_INDEX = FILE_SIZE_UNITS.length - 1;

function formatFileSize(bytes: number): string {
  if (bytes < BYTES_PER_UNIT) {
    return `${bytes} B`;
  }

  let value = bytes;
  let unitIndex = 0;

  while (value >= BYTES_PER_UNIT && unitIndex < LAST_UNIT_INDEX) {
    value /= BYTES_PER_UNIT;
    unitIndex += 1;
  }

  return `${value.toFixed(DECIMAL_PLACES_ABOVE_BYTES)} ${FILE_SIZE_UNITS[unitIndex]}`;
}

export { formatFileSize };
